import React from 'react';
import {
  Box,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text
} from '@chakra-ui/react';
import CloseModalIcon from '../../../assets/close-modal-icon.svg';
import Button from '../../Button';

function ConfirmModal(props) {
  const {
    isOpen,
    onClick,
    Icon,
    title,
    desc,
    titleBtn,
    onClose,
    isLoading,
    titleBtnCancel,
    textAlign = 'center',
    type
  } = props;
  return (
    <>
      <Modal isOpen={isOpen} isCentered onClose={onClose}>
        <ModalOverlay />
        <ModalContent borderRadius={'12px'} w={'423px'} p={'24px'} bgColor={'light.200'}>
          <ModalHeader p={0} w={'100%'} m={0} maxWidth={'unset'}>
            <div className="flex w-full items-center justify-between pb-2 border-b border-earth-brown-50">
              <p className="text-xl font-[800]">{title}</p>
              <Image
                className="w-[40px] h-[40px] cursor-pointer"
                src={CloseModalIcon}
                onClick={onClose}
                alt=""
              />
            </div>
          </ModalHeader>
          <ModalBody p={0} my={'24px'}>
            {Icon ? (
              <Box w={'12.5rem'} h={'12.5rem'} p={'1.5625rem'} margin="auto">
                <img src={Icon} alt="" className="w-[9.375rem] h-[9.375rem] block"></img>
              </Box>
            ) : (
              <></>
            )}
            <Flex flexDirection={'column'} gap={'10px'}>
              <Text fontSize={'1.125rem'} textAlign={textAlign}>
                {desc}
              </Text>
            </Flex>
          </ModalBody>
          <ModalFooter p="0" gap={'10px'}>
            <div className="flex items-center justify-end w-full">
              <Button
                type="submit"
                variant={'outline'}
                onClick={onClose}
                className={`h-[42px] ${type ? 'w-fit' : 'w-full'} whitespace-nowrap`}
              >
                {titleBtnCancel ?? 'Cancel'}
              </Button>
              <Button
                variant={type === 'approve' ? 'primary' : 'red'}
                onClick={onClick}
                isLoading={isLoading}
                className={`ml-[10px] ${type ? 'w-fit' : 'w-full'} h-[42px] whitespace-nowrap`}
              >
                {titleBtn}
              </Button>
            </div>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default ConfirmModal;
